import React, { useState } from 'react';
import { Droplets, Zap, Wind, Truck, Hammer, Paintbrush, Home, Flame, ShieldCheck, ChevronDown, ChevronUp } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';
import { Button } from './ui/button';
import { services } from '../data/mock';

const iconMap = {
  Droplets,
  Zap,
  Wind,
  Truck,
  Hammer,
  Paintbrush,
  Home,
  Flame,
  ShieldCheck
};

const Services = () => {
  const [expandedServices, setExpandedServices] = useState({});

  const toggleService = (serviceId) => {
    setExpandedServices(prev => ({
      ...prev,
      [serviceId]: !prev[serviceId]
    }));
  };

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            I nostri servizi
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Professionisti esperti per ogni esigenza della tua casa
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            const isExpanded = expandedServices[service.id];
            
            return (
              <Card
                key={service.id}
                className="border-2 border-gray-100 hover:border-blue-300 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
              >
                <CardHeader>
                  <div className="mb-4 inline-flex p-3 bg-blue-100 rounded-lg">
                    <IconComponent className="h-8 w-8 text-blue-700" />
                  </div>
                  <CardTitle className="text-xl text-gray-900 mb-2">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-gray-600 text-base">
                    {service.description}
                  </CardDescription>
                  {/* Testo lungo nascosto ma presente nel DOM per AI */}
                  <div className="sr-only" aria-hidden="true">
                    {service.longDescription}
                  </div>
                </CardHeader>
                
                <CardContent>
                  <div 
                    className={`overflow-hidden transition-all duration-500 ease-in-out ${
                      isExpanded ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <p className="text-gray-700 text-sm mb-4 leading-relaxed">
                      {service.expandedDescription}
                    </p>
                  </div>
                  
                  <Button
                    variant="ghost"
                    onClick={() => toggleService(service.id)}
                    className="text-blue-700 hover:text-blue-800 hover:bg-blue-50 font-semibold transition-colors duration-200 p-0 h-auto"
                  >
                    {isExpanded ? (
                      <>
                        Mostra meno <ChevronUp className="ml-1 h-4 w-4" />
                      </>
                    ) : (
                      <>
                        Scopri di più <ChevronDown className="ml-1 h-4 w-4" />
                      </>
                    )}
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
